import React, { Component } from "react";

// Images
import latestResultIc from "../../../images/icon/LatestResult-ic.png";
//common
import { getWebData, getGameRules } from "../../../utils/common.utils";
import rules from "../../../utils/rules.json";

export default class TournamentRulesV2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rules: props?.tournamentDetails?.rules ? props?.tournamentDetails?.rules : [],
    };
    this.gameRules = getGameRules(props.tournamentDetails?.gameDetails?.name);
    this.websiteData = getWebData();

    // Use the imported rules.json file
    this.mandatoryRules = rules;
  }

  componentWillReceiveProps(props) {
    this.setState({
      rules: props?.tournamentDetails?.rules ? props?.tournamentDetails?.rules : [],
    });
  }

  // Format category names for display
  formatCategoryName = category => {
    return category
      .replace(/([A-Z])/g, " $1") // Insert a space before all capital letters
      .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
  };

  render() {
    const mandatoryRules = this.websiteData?.STATIC_PAGE?.RULES?.SET_UP_RULES?.split("&&");
    const bettingRules =
      this.websiteData?.STATIC_PAGE?.BETTING_RULES?.SET_UP_BETTING_RULES?.split("&&");

    return (
      <section className="tournament-rules text-white">
        <div className="container">
          <div className="row">
            {/* Custom Tournament Rules */}
            {this.state.rules.length > 0 && (
              <div className="col-12 ">
                <span className="d-flex">
                  <img
                    src={latestResultIc}
                    className=""
                    alt=""
                    style={{ height: "20px", width: "16px" }}
                  />
                  <h1 className="fs-16 fw-700 ms-2">Rules</h1>
                </span>
                <div className="row">
                  <div className="col-12">
                    <ol>
                      {this.state.rules?.map((rule, i) => {
                        return (
                          <li className="fs-14 fw-400 mb-1" key={i}>
                            {rule}
                          </li>
                        );
                      })}
                    </ol>
                  </div>
                </div>
              </div>
            )}

            {/* Mandatory Rules from rules.json */}
            <div className="col-12 mt-4">
              {Object.keys(this.mandatoryRules.tournamentRules).map((category, categoryIndex) => (
                <div className="row mt-2" key={categoryIndex}>
                  <div className="col-12">
                    <span className="d-flex align-items-center">
                      <img
                        src={latestResultIc}
                        className=""
                        alt=""
                        style={{ height: "16px", width: "12px" }}
                      />
                      <h5 className="fs-15 fw-600 mb-0 ms-2">
                        {this.formatCategoryName(category)}
                      </h5>
                    </span>
                    <ol type="a">
                      {this.mandatoryRules.tournamentRules[category].map((rule, i) => (
                        <li className="fs-14 fw-400 mb-1" key={i}>
                          {rule}
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              ))}
            </div>

            {/* Original Mandatory Rules (optional - you can comment out or remove if not needed) */}
            {mandatoryRules && (
              <div className="col-12 mt-4">
                <span className="d-flex align-items-center">
                  <img
                    src={latestResultIc}
                    className=""
                    alt=""
                    style={{ height: "20px", width: "16px" }}
                  />
                  <h5 className="fs-16 fw-700 ms-2 mb-0">Mandatory Rules</h5>
                </span>
                <div className="row">
                  <div className="col-12">
                    <ol>
                      {mandatoryRules?.map((rule, i) => {
                        return (
                          <li className="fs-14 fw-400 mb-1" key={i}>
                            {rule}
                          </li>
                        );
                      })}
                    </ol>
                  </div>
                </div>
              </div>
            )}

            {/* Staking Rules */}
            {bettingRules && (
              <div className="col-12 mt-4">
                <span className="d-flex align-items-center">
                  <img
                    src={latestResultIc}
                    className=""
                    alt=""
                    style={{ height: "20px", width: "16px" }}
                  />
                  <h5 className="fs-16 fw-700 ms-2 mb-0">Staking Rules</h5>
                </span>
                <div className="row">
                  <div className="col-12">
                    <ol>
                      {bettingRules?.map((rule, i) => {
                        return (
                          <li className="fs-14 fw-400 mb-1" key={i}>
                            {rule}
                          </li>
                        );
                      })}
                    </ol>
                  </div>
                </div>
              </div>
            )}

            {/* Game Rules */}
            {this.gameRules?.[0]?.rule && (
              <div className="col-12 mt-4">
                <span className="d-flex align-items-center">
                  <img
                    src={latestResultIc}
                    className=""
                    alt=""
                    style={{ height: "20px", width: "16px" }}
                  />
                  <h5 className="fs-16 fw-700 ms-2 mb-0">Game Rules</h5>
                </span>
                <div className="row">
                  <div className="col-12">
                    <ol>
                      {this.gameRules?.[0]?.rule?.map((rule, i) => {
                        return (
                          <li className="fs-14 fw-400 mb-1" key={i}>
                            {rule.description}
                          </li>
                        );
                      })}
                    </ol>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}
